import paginationActions from './actions';
import paginationHelpers from './helpers';
import paginationReducer, { initialPaginationState } from './reducer';

export default {
  reducer: paginationReducer,
  actions: paginationActions,
  state: initialPaginationState,
  helpers: paginationHelpers,
};
